import React from 'react';
import _get from 'lodash-es/get';
import Download from 'sushiweb/Icons/all/Download';
import grey from 'sushiweb/tokens/color/grey';
import { GET_REPORT_DETAILS } from '../constants/urls';
import { reportStatusEnum } from '../pages/common/components/constants';
import { DownloadIconWrapper } from '../pages/common/styles';
import zfetch from '../pages/common/utils/zfetch';

export const getReportFile = report => {
  if (report.status !== reportStatusEnum.REPORT_STATUS_GENERATED) {
    return '';
  }
  const generateReport = () => {
    zfetch(GET_REPORT_DETAILS, {
      method: 'GET',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      params: {
        report_id: report.report_id,
      },
    })
      .then(res => res.json())
      .then(res => {
        const data = _get(res, 'data');
        window.open(_get(data, 'file_path'), '_blank', 'noopener');
      })
      .catch(error => {
        console.error(error);
      });
  };
  return (
    <DownloadIconWrapper onClick={generateReport}>
      <Download color={grey.z800} size={16} />
    </DownloadIconWrapper>
  );
};
